import React, { useState, useEffect } from "react";
import TypedModal from "@/components/TypedModal/TypedModal";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

interface AttendanceNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  attendeeName: string;
  notes: string | null;
  onSave?: (notes: string) => void;
  isLoading?: boolean;
}

function AttendanceNotesModal({
  isOpen,
  onClose,
  attendeeName,
  notes,
  onSave,
  isLoading = false,
}: AttendanceNotesModalProps) {
  const [notesValue, setNotesValue] = useState(notes || "");

  useEffect(() => {
    setNotesValue(notes || "");
  }, [notes]);

  const handleSave = () => {
    if (!onSave) {
      onClose();
      return;
    }

    onSave(notesValue);
  };

  return (
    <TypedModal
      ariaHideApp={false}
      isOpen={isOpen}
      onRequestClose={onClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          borderRadius: "8px",
          padding: "24px",
          background: "white",
          boxShadow: "0 10px 25px rgba(0,0,0,.3)",
          width: "calc(100% - 32px)",
          maxWidth: "500px",
          minBlockSize: "fit-content",
          overflowY: "auto",
        },
        overlay: {
          backgroundColor: "rgba(0,0,0,0.3)",
          zIndex: 9999,
        },
      }}
    >
      <h3 className="text-xl font-semibold text-gray-900">
        Attendance Notes - {attendeeName}
      </h3>

      <div className="mt-4">
        <Textarea
          className="w-full min-h-[120px]"
          disabled={isLoading}
          onChange={(e) => setNotesValue(e.target.value)}
          placeholder="Enter notes about this attendee's attendance status..."
          value={notesValue}
        />
      </div>

      <div className="mt-6 flex justify-end space-x-3">
        <Button disabled={isLoading} onClick={onClose} variant="outline">
          Cancel
        </Button>
        <Button disabled={isLoading} onClick={handleSave}>
          {isLoading ? "Saving..." : "Save Notes"}
        </Button>
      </div>
    </TypedModal>
  );
}

export default AttendanceNotesModal;
